<script>
  import { Link } from 'svelte-navigator';
  let classid = '';
</script>

<div>
  <div class="field">
    <div class="control">
      <input
        bind:value={classid}
        class="input is-medium"
        type="text"
        placeholder="Code"
      />
    </div>
  </div>
  {#if !classid}
    <button class="button is-block is-primary is-fullwidth is-medium" disabled>
      Join
    </button>
  {:else}
    <Link
      to="/join/{classid}"
      class="button is-block is-primary is-fullwidth is-medium"
    >
      Join
    </Link>
  {/if}
  <br />
  <small><em>Get the class code from your class leader.</em></small>
</div>
